import withTracker from '.././withTracker';
import ForgotPassword from '../../containers/subscriber/ForgotPassword';

const subscriberForgotPassword = {
  path: '/subscribers/forgot-password',
  component: withTracker(ForgotPassword)
};

export default subscriberForgotPassword;
